
import errorParseNetwork from "~/helpers/errorParseNetwork";

export default {
  name: "CityInfo",

  data: function () {
    return {
      cityCurrentByIp: null
    }
  },

  computed: {
    currentCity: function () {
      return this.$store.state.appState?.config?.city?.model?.name
    },
  },

  mounted: async function () {
    await this.checkCoockies();
  },

  methods: {
    openPopUpCity: function () {
      this.cityCurrentByIp = null;
      this.$store.commit("city-select/setOpen", true);
    },
    checkCoockies: async function () {
      const acceptCity = this.$cookies.get('accept_city');
      if (!!acceptCity) {
        return
      }

      const currentByIp = await this.$api.agent.transport.get('/cities/current-by-ip').then((res) => {
        return res.data
      }).catch(() => {
        return null
      });
      if (!currentByIp) {
        return
      }

      this.cityCurrentByIp = currentByIp;
    },

    setCurrenctCity: async function (city) {
      this.$store.commit("loading/setLoading", {name: "popUpLoading", value: true});

      const cookiesOpt = this.$getCookiesOpt({
        path: '/',
        maxAge: 60 * 60 * 24 * 60 * 365
      });
      this.$cookies.set('accept_city', city.id, cookiesOpt);

      const body = {
        city_id: city.id
      };
      const response = await this.$api.agent.transport.put('cities/current', body).then((res) => {
        return res.data
      }).catch((err) => {
        return {error: errorParseNetwork(err.response)}
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", {name: "popUpLoading", value: false});
        this.$toast.error(response.error);

        return
      }

      const activeCitySubDomain = city?.sub_domain || "";
      const currentFullPath = this.$route?.path || "";
      const locationHost = window.location?.host || "";
      const isSubdomain = Boolean(locationHost.split(".").length >= 3);
      const host = Boolean(isSubdomain) ? locationHost.split(".")?.slice(-(locationHost.split(".").length - 1)).join('.') : locationHost;

      const currentUrl = new URL(window.location.href);
      let currentSearch = new URLSearchParams(currentUrl.search);
      currentSearch.delete('c');
      currentSearch = currentSearch.toString();

      const search = Boolean(currentSearch) ? `?${currentSearch}&c=${city.id}` : `?c=${city.id}`;
      const reloadUrl = `${window?.location?.protocol || "https:"}//${Boolean(activeCitySubDomain) ? `${activeCitySubDomain}.` : ""}${host}${currentFullPath}${search}`
      location.href = reloadUrl;
    }
  }
}
